var map = {
	"./de/bg.jpg": "Hdjd",
	"./en/bg.jpg": "f5FO",
	"./es/bg.jpg": "PrEA",
	"./fr/bg.jpg": "2HM1",
	"./ja/bg.jpg": "VGly",
	"./ko/bg.jpg": "iYgN",
	"./pt/bg.jpg": "CW/n",
	"./ru/bg.jpg": "3kuq",
	"./tc/bg.jpg": "ooxf",
	"./th/bg.jpg": "1j6E"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iMCW";